<div class="wrapper">
  <div class="abs-center wd-xl">
    <!-- START card-->
    <div class="text-center mb-4">
      <div class="text-lg mb-3">404</div>
      <p class="lead m0">We couldn't find this page.</p>
      <p>The page you are looking for does not exists.</p>
    </div>

    <ul class="list-inline text-center text-sm mb-4">
      <li class="list-inline-item">
        <a class="text-muted" [routerLink]="'/'"><em class="icon-home"></em> Go to App</a>
      </li>
      <li class="text-muted list-inline-item">|</li>
      <li class="list-inline-item">
        <a class="text-muted" href="#" title="Lock screen" (click)="logOut($event)">
          <em class="icon-lock"></em> Logout
        </a>
      </li>
    </ul>
    <div class="p-3 text-center">
      <span>&copy;</span>
      <span>{{ settings.getAppSetting('year') }}</span>
      <span class="mx-2">-</span>
      <span>{{ settings.getAppSetting('name') }}</span>
      <br />
      <span>{{ settings.getAppSetting('description') }}</span>
    </div>
  </div>
</div>
